import React from 'react';
import cx from 'clsx';
import { useTranslations } from "@montana/containers/translations";

interface IMobileMenuToggleProps {
    isOpen: boolean;
    invertText?: boolean;
    onToggleCallback: () => void;
}

export const MobileMenuToggle: React.FC<IMobileMenuToggleProps> = React.memo(({ onToggleCallback, isOpen, invertText }: IMobileMenuToggleProps): JSX.Element => {
    const translate = useTranslations();

    const translatedTexts = {
        openMenu: translate((translations): string => translations.mobileMenu.openMenu, "Åbn menu"),
        closeMenu: translate((translations): string => translations.mobileMenu.closeMenu, "Luk menu")
    };

    return (
        <div className="header__menu-button">
            <button
                className={cx('header__button', 'header__button--mobile-menu', {
                    'header__button--active': isOpen,
                    'header__button--invert': isOpen || invertText
                })}
                onClick={onToggleCallback}
                type="button"
                aria-label={isOpen ? translatedTexts.closeMenu : translatedTexts.openMenu}
            >
                <span className="header__button-icon">
                    <span className={cx('header__button-line', { 'header__button-line--invert': invertText })} />
                    <span className={cx('header__button-line', { 'header__button-line--invert': invertText })} />
                    <span className={cx('header__button-line', { 'header__button-line--invert': invertText })} />
                </span>
            </button>
        </div>
    );
});

MobileMenuToggle.displayName = 'MobileMenuToggle';